// libraries
import { gql, GraphQLClient } from 'graphql-request';
import { BASE_URL, headers, headers2, WORKER_URL } from '../configs/constants';
import { isPositiveGraphqlInt } from '../utils/graphql-int';
import { normalizeHost } from '../utils/url';

const BOT_PATTERNS = [
  /googlebot/i, /bingbot/i, /baiduspider/i, /yandexbot/i,
  /duckduckbot/i, /facebookexternalhit/i, /ia_archiver/i,
  /crawler/i, /spider/i, /bot/i
];

const getGraphqlRequestOrigin = (origin?: string) =>
  typeof window !== 'undefined' ? window.location.origin : origin || '';

const getSsrForwardedHostHeaders = (origin?: string) => {
  if (typeof window !== 'undefined') return {};

  const normalizedOriginHost = normalizeHost(origin || '');
  if (!normalizedOriginHost) return {};

  return {
    'x-forwarded-host': normalizedOriginHost,
  };
};

function isLikelyBot() {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  if (BOT_PATTERNS.some((re) => re.test(ua))) return true;
  if ((navigator as any).webdriver) return true; // automação
  return false;
}

// requests
//query para pegar os imoveis para o carrossel de acordo com os filtros passados
export async function properties_carrossel(info: any, url_b?: any, origin?: string, codsite?: any) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    let endpoint = BASE_URL;

    if(typeof window === 'undefined' && url_b)
        endpoint = `${(url_b || '').replace(/\/$/, '')}/api/gql`
    else
        endpoint = '/api/gql'

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: getGraphqlRequestOrigin(origin),
            'x-graphql-client-name': getGraphqlRequestOrigin(origin),
            codsite: codsite ? codsite : 0,
            ...getSsrForwardedHostHeaders(origin)
        },
    });

    const query = gql`
        {
            imoveis(pagina: 1, ordenar: Inclusao, ordem: desc 
            ${info.id_tipo ? ', id_tipo: ' + info.id_tipo : ''}
            ${info.venda || ((info.preco_max > 0 || info.preco_min > 0) && !info.venda && !info.aluguel) ? ', venda: ' + 1 : ''}
            ${info.aluguel ? ', aluguel: ' + 1 : ''}
            ${info.id_categoria > 0 ? `,id_categoria: ${info.id_categoria}` : ''}
            ${info.id_cidade ? `,id_cidade: ${info.id_cidade}` : ''}
            ${info.id_bairro ? `,id_bairro: ${[info.id_bairro]}` : ''}
            ${info.preco_min && (info.venda || (!info.venda && !info.aluguel)) ? `,preco_venda_min: ${info.preco_min}` : ''}
            ${info.preco_max > info.preco_min && (info.venda || (!info.venda && !info.aluguel)) ? `,preco_venda_max: ${info.preco_max}` : ''}
            ${info.preco_min && info.aluguel ? `,preco_locacao_min: ${info.preco_min}` : ''}
            ${info.preco_max > info.preco_min && info.aluguel ? `,preco_locacao_max: ${info.preco_max}` : ''}
            ${info.id_empreendimento ? `,id_empreendimento: ${info.id_empreendimento}`: ''}
            ${info.id_caracteristica > 0 ? ",id_caracteristic: "+ info.id_caracteristica : ''}
        ) {
                count,
                imoveis {
                    id
                    mini_banner_texto
                    qtd_salas
                    pais
                    area_tipo
                    tipo {
                        id
                        nome
                    }
                    categoria {
                        id
                        nome
                    }
                    cidade {
                        id
                        nome
                    }
                    bairro {
                        id
                        nome
                        id_cidade
                    }
                    referencia
                    data_entrega
                    temporada
                    data_edicao
                    id
                    d1
                    disponibilidade
                    venda
                    aluguel
                    endereco
                    titulo
                    descricao
                    dormitorios
                    suites
                    bloquear_fotos
                    banheiros
                    garagems
                    boxes
                    origem
                    mostrar_endereco
                    preco_venda
                    exibir_preco_venda
                    moeda_imovel
                    preco_iptu
                    destaque
                    link_video
                    tour360
                    preco_locacao
                    esconder_home
                    exibir_preco_locacao
                    exibir_preco_iptu
                    exibir_preco_condominio
                    preco_condominio
                    area_construida
                    area_total
                    terreno
                    area_privativa
                    area_util
                    latitude_longitude
                    palavras_chave
                    fotos {
                        id
                        id_imovel
                        nome
                        destaque
                        posicao
                        url_foto
                        url_marca
                        url_spaces_cdn
                        url_spaces_migracao
                    }
                    caracteristicas {
                        caracteristica {
                            id
                            nome
                            tipo
                        }
                    }
                    visualizacoes
                    preco_especial {
                        preco_especial_venda
                        preco_especial_locacao
                    }
                    empreendimento {
                        id
                        nome
                        referencia
                        endereco
                        destaque
                        meta_description
                        meta_keywords
                        meta_title
                        descricao
                        foto_destaque
                    }
                }
            }
        }
    `;

    try {
        const data = await graphQLClient.request(query);
        return data;
    } catch (error) {
        return null;
    }
}

//query para pegar os imoveis com filtros
export async function properties(page: number, id?: number, id_tipo?: any, temporada?: number, url_b?: any, origin?: string, codsite?: number, venda?: number, aluguel?: number) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    const endpoint = url_b || BASE_URL;

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0
        },
    });

    const query = gql`
        {
            imoveis(pagina: ${page}, ordenar: Inclusao, ordem: desc ${
        id ? `, id: ${id}` : ''}
        ${id_tipo ? ', id_tipo: ' + id_tipo : ''}
        ${temporada ? ', temporada: ' + temporada : ''}
        ${venda ? ', venda: ' + venda : ''}
        ${aluguel ? ', aluguel: ' + aluguel : ''}
        ) {
                count,
                imoveis {
                    id
                    mini_banner_texto
                    qtd_salas
                    pais
                    area_tipo
                    tipo {
                        id
                        nome
                    }
                    categoria {
                        id
                        nome
                    }
                    cidade {
                        id
                        nome
                    }
                    bairro {
                        id
                        nome
                        id_cidade
                    }
                    referencia
                    data_entrega
                    temporada
                    data_edicao
                    id
                    d1
                    disponibilidade
                    venda
                    aluguel
                    endereco
                    titulo
                    descricao
                    dormitorios
                    suites
                    bloquear_fotos
                    banheiros
                    garagems
                    boxes
                    origem
                    mostrar_endereco
                    preco_venda
                    exibir_preco_venda
                    moeda_imovel
                    preco_iptu
                    destaque
                    link_video
                    tour360
                    preco_locacao
                    esconder_home
                    exibir_preco_locacao
                    exibir_preco_iptu
                    exibir_preco_condominio
                    preco_condominio
                    area_construida
                    area_total
                    terreno
                    area_privativa
                    area_util
                    latitude_longitude
                    palavras_chave
                    fotos {
                        id
                        id_imovel
                        nome
                        destaque
                        posicao
                        url_foto
                        url_marca
                        url_spaces_cdn
                        url_spaces_migracao
                    }
                    caracteristicas {
                        caracteristica {
                            id
                            nome
                            tipo
                        }
                    }
                    visualizacoes
                    preco_especial {
                        preco_especial_venda
                        preco_especial_locacao
                    }
                    empreendimento {
                        id
                        nome
                        referencia
                        endereco
                        destaque
                        meta_description
                        meta_keywords
                        meta_title
                        descricao
                        foto_destaque
                    }
                }
            }
        }
    `;

    try {
        const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}

//query para pegar os imoveis de um empreendimento
export async function imoveis_empreendimento(id_empreendimento: number, origin?: string, codsite?: number) {
    if ((!origin && typeof window === 'undefined') || !id_empreendimento) {
        return null;
    }

    const endpoint = BASE_URL;

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0
        },
    });

    const query = gql`
    {
        imoveis(pagina: 1, ordenar: Inclusao, ordem: desc, id_empreendimento: ${id_empreendimento})
        {
            count
            imoveis {
                id
                estado
                qtd_salas
                pais
                tipo {
                    nome
                }
                cidade {
                    nome
                }
                bairro {
                    nome
                }
                exclu
                referencia
                data_entrega
                transacao
                id_empreendimento
                venda
                aluguel
                temporada
                finalidade
                cep
                endereco
                numero
                complemento
                titulo
                dormitorios
                suites
                origem
                banheiros
                garagems
                boxes
                situacao
                mini_banner_texto
                data_edicao
                mostrar_endereco
                tour360
                preco_venda
                exibir_preco_venda
                moeda_imovel
                preco_condominio
                disponibilidade
                d1
                disponivel_t
                disponivel
                destaque
                esconder_home
                link_video
                preco_locacao
                exibir_preco_locacao
                area_construida
                area_total
                terreno
                area_privativa
                area_util
                latitude_longitude
                fotos {
                    url_foto
                    url_foto_menor
                    url_marca
                    destaque
                    url_spaces_cdn
                    url_spaces_migracao
                }
                preco_especial {
                    preco_especial_locacao
                    preco_especial_venda
                }
                empreendimento {
                    nome
                    foto_destaque
                }
                area_tipo
            }
        }
    }`;

    
    try {
        
const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}


//query para pegar os 12 imoveis mais novos para colocar na home
export async function imoveis_novidades(url_b?: any, origin?: string, codsite?: number, url?: any) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    let endpoint = BASE_URL;

    if(typeof window === 'undefined' && url_b)
        endpoint = `${(url_b || '').replace(/\/$/, '')}/api/gql`
    else
        endpoint = '/api/gql'

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: getGraphqlRequestOrigin(origin),
            'x-graphql-client-name': getGraphqlRequestOrigin(origin),
            codsite: codsite ? codsite : 0,
            query: 'imoveis_novidades',
            ...getSsrForwardedHostHeaders(origin)
        },
    });

    const query = gql`
    {
        imoveis_novidades(quantidade: 12) {
            exclu
            id
            estado
            pais
            tipo {
                nome
            }
            cidade {
                nome
            }
            bairro {
                nome
            }
            referencia
            data_entrega
            transacao
            id_empreendimento
            venda
            aluguel
            temporada
            finalidade
            cep
            endereco
            numero
            complemento
            titulo
            origem
            dormitorios
            suites
            banheiros
            garagems
            boxes
            situacao
            mini_banner_texto
            data_edicao
            mostrar_endereco
            tour360
            preco_venda
            exibir_preco_venda
            moeda_imovel
            preco_condominio
            disponibilidade
            d1
            disponivel_t
            disponivel
            destaque
            esconder_home
            link_video
            preco_locacao
            exibir_preco_locacao
            area_construida
            area_total
            terreno
            area_privativa
            area_util
            fotos {
                url_foto
                url_foto_menor
                url_marca
                url_spaces_cdn
                url_spaces_migracao
                destaque
            }
            preco_especial {
                preco_especial_locacao
                preco_especial_venda
            }
            empreendimento {
                nome
                foto_destaque
            }
            area_tipo
        }
    }
    `;

    try {
        const data = await graphQLClient.request(query);
  
        return data;
    } catch (error) {
        return null;
    }
}

//query para pegar os 10 imoveis em destaque para colocar no carrossel da home
export async function propertiesTop10(url_b?: any, origin?: string, codsite?: number, url?: any) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    let endpoint = BASE_URL;

    if(typeof window === 'undefined' && url_b)
        endpoint = `${(url_b || '').replace(/\/$/, '')}/api/gql`
    else
        endpoint = '/api/gql'

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: getGraphqlRequestOrigin(origin),
            'x-graphql-client-name': getGraphqlRequestOrigin(origin),
            codsite: codsite ? codsite : 0,
            query: 'imoveis_destaque',
            ...getSsrForwardedHostHeaders(origin)
        },
    });

    const query = gql`{
        imoveis_destaque(quantidade: 10) {
        exclu
        id
        estado
        pais
        tipo {
            nome
        }
        cidade {
            nome
        }
        bairro {
            nome
        }
        referencia
        data_entrega
        transacao
        id_empreendimento
        venda
        aluguel
        temporada
        finalidade
        cep
        endereco
        numero
        complemento
        titulo
        dormitorios
        suites
        banheiros
        origem
        garagems
        boxes
        situacao
        mini_banner_texto
        data_edicao
        mostrar_endereco
        tour360
        preco_venda
        exibir_preco_venda
        moeda_imovel
        preco_condominio
        disponibilidade
        d1
        disponivel_t
        disponivel
        destaque
        esconder_home
        link_video
        preco_locacao
        exibir_preco_locacao
        area_construida
        area_total
        terreno
        area_privativa
        area_util
        fotos {
            url_foto
            url_foto_menor
            url_marca
            destaque
            url_spaces_cdn
            url_spaces_migracao
        }
        preco_especial {
            preco_especial_locacao
            preco_especial_venda
        }
        empreendimento {
            nome
            foto_destaque
        }
        area_tipo
        }
    }
    `;

    try {
        const data = await graphQLClient.request(query);
       
        return data;
    } catch (error) {
        return null;
    }
}

//query para pegar os imoveis para o carrossel da home com filtros personalizado
export async function carrossel_select(carrossel: number, url_b?: any, origin?: string, codsite?: number, url?: any) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    let endpoint = BASE_URL;

    if(url == 'teste' || url_b){
        endpoint = '/api/gql';
    }

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0,
            query: `carrossel_select_${carrossel}`
        },
    });

    const query = gql`{
        carrossel_select(quantidade: 12,carrossel: ${carrossel}) {
        exclu
        id
        estado
        pais
        tipo {
            nome
        }
        cidade {
            nome
        }
        bairro {
            nome
        }
        referencia
        data_entrega
        transacao
        id_empreendimento
        venda
        aluguel
        temporada
        finalidade
        cep
        endereco
        numero
        complemento
        titulo
        origem
        dormitorios
        suites
        banheiros
        garagems
        boxes
        situacao
        mini_banner_texto
        data_edicao
        mostrar_endereco
        tour360
        preco_venda
        exibir_preco_venda
        moeda_imovel
        preco_condominio
        disponibilidade
        d1
        disponivel_t
        disponivel
        destaque
        esconder_home
        link_video
        preco_locacao
        exibir_preco_locacao
        area_construida
        area_total
        terreno
        area_privativa
        area_util
        fotos {
            url_foto
            url_foto_menor
            url_marca
            destaque
            url_spaces_cdn
            url_spaces_migracao
        }
        preco_especial {
            preco_especial_locacao
            preco_especial_venda
        }
        empreendimento {
            nome
            foto_destaque
        }
        area_tipo
        }
    }
    `;

    try {
            const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}

//query para pegar os imoveis para o carrossel da home com filtros personalizado
export async function propertiesFilter(
    id_categoria: any,
    page: number,
    idCity?: number | null,
    idBairro?: any | null,
    idTipo?: any | null,
    referencia?: any,
    precoVendaMin?: number | null,
    precoVendaMax?: number | null,
    precoLocacaoMin?: number | null,
    precoLocacaoMax?: number | null,
    venda?: number,
    aluguel?: number,
    company?: number,
    ordenar?: any,
    garagemsMin?: number | null,
    dormitoriosMin?: number | null,
    suitesMin?: number | null,
    banheirosMin?: number | null,
    agenciador?: Number | null,
    precoTemporadaMin?: number | null,
    precoTemporadaMax?: number | null,
    temporada?: number,
    id_imovel?: any | null,
    origin?: string,
    codsite?: number,
    id_caracteristica?: any,
    area_min?: number,
    area_max?: number,
    mapa?: number,
    ano_entr?: any,
    id_estado?: any,
    )
    {
        if (!origin && typeof window === 'undefined') {
            return null;
        }

        let suitesMax = suitesMin
        if(suitesMin == 5)
            suitesMax = 0
        let garagemsMax = garagemsMin
        if(garagemsMin == 5)
            garagemsMax = 0
        let dormitoriosMax = dormitoriosMin
        if(dormitoriosMin == 5)
            dormitoriosMax = 0
        let banheirosMax = banheirosMin
        if(banheirosMin == 5)
            banheirosMax = 0

        const endpoint = BASE_URL;

        const graphQLClient = new GraphQLClient(endpoint, {
            headers: {
                ...headers,
                dominion: typeof window !== 'undefined' ? window.location.origin : origin,
                'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
                codsite: codsite ? codsite : 0
            },
        });

    const query = gql`
    {
        imoveis_busca(pagina: ${page},
        ordenar: ${ordenar?.value?.split('-')[1] || 'Inclusao'},
        ordem: ${ordenar?.value?.split('-')[0] || 'desc'}
        ${id_categoria>0 ? ",id_categoria:"+id_categoria : ''}
        ${id_imovel && id_imovel != undefined && id_imovel != "" ? ",id: ["+id_imovel+"]" : ''}
        ${idCity ? `,id_cidade: ${idCity}` : ''}
        ${idBairro ? `,id_bairro: ${idBairro}` : ''}
        ${idTipo ? `,id_tipo: ${idTipo}` : ''}
        ${referencia?.length > 2 ? `,referencia: ${referencia}` : (`${venda ? `,venda: ${venda}` : ''}
        ${aluguel ? `,aluguel: ${aluguel}` : ''}
        ${temporada ? `,temporada: ${temporada}` : ''}
        ${precoVendaMin ? `,preco_venda_min: ${precoVendaMin}` : ''}
        ${precoVendaMax ? `,preco_venda_max: ${precoVendaMax}` : ''}
        ${precoLocacaoMin ? `,preco_locacao_min: ${precoLocacaoMin}` : ''}
        ${agenciador ? `,id_agenciador: ${agenciador}` : ''}
        ${precoLocacaoMax ? `,preco_locacao_max: ${precoLocacaoMax}` : ''}`)}
        ${company ? `,id_empreendimento: ${company}`: ''}
        ${garagemsMin ? `,garagems_min: ${garagemsMin}` : ''}
        ${garagemsMax ? `,garagems_max: ${garagemsMax}` : ''}
        ${dormitoriosMin ? `,dormitorios_min: ${dormitoriosMin}` : ''}
        ${dormitoriosMax ? `,dormitorios_max: ${dormitoriosMax}` : ''}
        ${suitesMin ? `,suites_min: ${suitesMin}` : ''}
        ${suitesMax ? `,suites_max: ${suitesMax}` : ''}
        ${banheirosMin ? `,banheiros_min: ${banheirosMin}` : ''}
        ${banheirosMax ? `,banheiros_max: ${banheirosMax}` : ''}
        ${area_min ? `,metragem_min: ${area_min}` : ''}
        ${area_max ? `,metragem_max: ${area_max}` : ''}
        ${id_estado ? `,id_estado: ${id_estado}` : ''}
        ${id_caracteristica && id_caracteristica != undefined && id_caracteristica != "" ? ",id_caracteristic: "+id_caracteristica : ''}
        ${ano_entr && ano_entr != undefined && ano_entr != "" ? ",ano_entrega: "+ano_entr : ''}
        ${mapa ? `,mapa: ${mapa}` : ''}
    ) {
        count
            imoveis {
                id
                estado
                pais
                tipo {
                    nome
                    id
                }
                categoria {
                    nome
                    id
                }
                cidade {
                    id
                    nome
                }
                bairro {
                    nome
                    id
                }
                referencia
                data_entrega
                transacao
                exclu
                id_empreendimento
                venda
                aluguel
                temporada
                finalidade
                titulo
                descricao
                origem
                dormitorios
                suites
                qtd_salas
                banheiros
                garagems
                boxes
                mini_banner_texto
                data_edicao
                mostrar_endereco
                incorporacao
                tour360
                preco_venda
                exibir_preco_venda
                moeda_imovel
                d1
                esconder_home
                link_video
                preco_locacao
                exibir_preco_locacao
                area_construida
                area_total
                terreno
                area_privativa
                area_util
                fotos {
                    url_foto
                }
                    preco_especial {
                    preco_especial_locacao
                    preco_especial_venda
                }
                empreendimento {
                    id
                    nome
                    foto_destaque
                }
                area_tipo
            }
        }
    }
    `;
    
    try {
        
        const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}

export async function propertiesFilterPromocao(
    id_categoria: any,
    page: number,
    idCity?: number | null,
    idBairro?: any | null,
    idTipo?: any | null,
    referencia?: any,
    precoVendaMin?: number | null,
    precoVendaMax?: number | null,
    precoLocacaoMin?: number | null,
    precoLocacaoMax?: number | null,
    venda?: number,
    aluguel?: number,
    company?: number,
    ordenar?: any,
    garagemsMin?: number | null,
    dormitoriosMin?: number | null,
    suitesMin?: number | null,
    banheirosMin?: number | null,
    agenciador?: Number | null,
    precoTemporadaMin?: number | null,
    precoTemporadaMax?: number | null,
    temporada?: number,
    id_imovel?: any | null,
    origin?: string, codsite?: number)
    {
        if (!origin && typeof window === 'undefined') {
            return null;
        }

        let suitesMax = suitesMin
        if(suitesMin == 5)
            suitesMax = 0
        let garagemsMax = garagemsMin
        if(garagemsMin == 5)
            garagemsMax = 0
        let dormitoriosMax = dormitoriosMin
        if(dormitoriosMin == 5)
            dormitoriosMax = 0
        let banheirosMax = banheirosMin
        if(banheirosMin == 5)
            banheirosMax = 0

        const endpoint = BASE_URL;

        const graphQLClient = new GraphQLClient(endpoint, {
            headers: {
                ...headers,
                dominion: typeof window !== 'undefined' ? window.location.origin : origin,
                'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
                codsite: codsite ? codsite : 0
            },
        });

    const query = gql`
        {
            imoveis_promocao(pagina: ${page},
            ordenar: ${ordenar?.value?.split('-')[1] || 'Inclusao'},
            ordem: ${ordenar?.value?.split('-')[0] || 'desc'}
    ${id_categoria>0 ? ",id_categoria:"+id_categoria : ''}
    ${id_imovel && id_imovel != undefined && id_imovel != "" ? ",id: ["+id_imovel+"]" : ''}
    ${idCity ? `,id_cidade: ${idCity}` : ''}
    ${idBairro ? `,id_bairro: ${idBairro}` : ''}
    ${idTipo ? `,id_tipo: ${idTipo}` : ''}
    ${referencia?.length > 2 ? `,referencia: ${referencia}` : (`${venda ? `,venda: ${venda}` : ''}
    ${aluguel ? `,aluguel: ${aluguel}` : ''}
    ${temporada ? `,temporada: ${temporada}` : ''}
    ${precoVendaMin ? `,preco_venda_min: ${precoVendaMin}` : ''}
    ${precoVendaMax ? `,preco_venda_max: ${precoVendaMax}` : ''}
    ${precoLocacaoMin ? `,preco_locacao_min: ${precoLocacaoMin}` : ''}
    ${agenciador ? `,id_agenciador: ${agenciador}` : ''}
    ${precoLocacaoMax ? `,preco_locacao_max: ${precoLocacaoMax}` : ''}`)}
    ${company ? `,id_empreendimento: ${company}`: ''}
    ${garagemsMin ? `,garagems_min: ${garagemsMin}` : ''}
    ${garagemsMax ? `,garagems_max: ${garagemsMax}` : ''}
    ${dormitoriosMin ? `,dormitorios_min: ${dormitoriosMin}` : ''}
    ${dormitoriosMax ? `,dormitorios_max: ${dormitoriosMax}` : ''}
    ${suitesMin ? `,suites_min: ${suitesMin}` : ''}
    ${suitesMax ? `,suites_max: ${suitesMax}` : ''}
    ${banheirosMin ? `,banheiros_min: ${banheirosMin}` : ''}
    ${banheirosMax ? `,banheiros_max: ${banheirosMax}` : ''}
    ) {
        count,
        imoveis {
            exclu
            id
            mini_banner_texto
            area_tipo
            pais
            qtd_salas
            tipo {
                id
                nome
            }
            categoria {
                id
                nome
            }
            cidade {
                id
                nome
            }
            bairro {
                id
                nome
                id_cidade
            }
            referencia
            data_entrega
            venda
            aluguel
            temporada
            data_edicao
            id
            d1
            disponibilidade
            endereco
            titulo
            descricao
            dormitorios
            suites
            banheiros
            garagems
            boxes
            origem
            bloquear_fotos
            mostrar_endereco
            preco_venda
            exibir_preco_venda
            moeda_imovel
            preco_iptu
            destaque
            link_video
            tour360
            preco_locacao
            esconder_home
            exibir_preco_locacao
            exibir_preco_iptu
            area_construida
            area_total
            terreno
            area_privativa
            area_util
            palavras_chave
            fotos {
                id
                id_imovel
                nome
                destaque
                url_spaces_cdn
                url_spaces_migracao
                posicao
                url_foto
                url_marca
            }
            caracteristicas {
                caracteristica {
                    id
                    nome
                    tipo
                }
            }
            visualizacoes
            preco_especial {
                preco_especial_venda
                preco_especial_locacao
            }
            empreendimento {
                id
                nome
                referencia
                endereco
                destaque
                meta_description
                meta_keywords
                meta_title
                descricao
                foto_destaque
            }
        }
        }
    }
    `;

    try {
        
const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}

//query para pegar os imoveis para montar o mapa no site com latitude e longitude
export async function propertiesMapa(
    id_categoria: any,
    page: number,
    idCity?: number | null,
    idBairro?: any | null,
    idTipo?: any | null,
    referencia?: any,
    precoVendaMin?: number | null,
    precoVendaMax?: number | null,
    precoLocacaoMin?: number | null,
    precoLocacaoMax?: number | null,
    venda?: number,
    aluguel?: number,
    company?: number,
    ordenar?: any,
    garagemsMin?: number | null,
    dormitoriosMin?: number | null,
    suitesMin?: number | null,
    banheirosMin?: number | null,
    agenciador?: Number | null,
    temporada?: number,
    mapa?: number,
    origin?: any, codsite?: number
) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    let suitesMax = suitesMin
    if(suitesMin == 5)
        suitesMax = 0
    let garagemsMax = garagemsMin
    if(garagemsMin == 5)
        garagemsMax = 0
    let dormitoriosMax = dormitoriosMin
    if(dormitoriosMin == 5)
        dormitoriosMax = 0
    let banheirosMax = banheirosMin
    if(banheirosMin == 5)
        banheirosMax = 0

    const endpoint = BASE_URL;

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0
        },
    });
    const query = gql`
        {
            imoveis(pagina: ${page},
            ordenar: ${ordenar?.value?.split('-')[1] || 'Inclusao'},
            ordem: ${ordenar?.value?.split('-')[0] || 'desc'}
    ${id_categoria>0 ? ",id_categoria:"+id_categoria : ''}
    ${idCity ? `,id_cidade: ${idCity}` : ''}
    ${idBairro ? `,id_bairro: ${idBairro}` : ''}
    ${idTipo ? `,id_tipo: ${idTipo}` : ''}
    ${referencia?.length > 2 ? `,referencia: ${referencia}` : (`${venda ? `,venda: ${venda}` : ''}
    ${aluguel ? `,aluguel: ${aluguel}` : ''}
    ${temporada ? `,temporada: ${temporada}` : ''}
    ${precoVendaMin ? `,preco_venda_min: ${precoVendaMin}` : ''}
    ${precoVendaMax ? `,preco_venda_max: ${precoVendaMax}` : ''}
    ${precoLocacaoMin ? `,preco_locacao_min: ${precoLocacaoMin}` : ''}
    ${agenciador ? `,id_agenciador: ${agenciador}` : ''}
    ${precoLocacaoMax ? `,preco_locacao_max: ${precoLocacaoMax}` : ''}`)}
    ${company ? `,id_empreendimento: ${company}`: ''}
    ${garagemsMin ? `,garagems_min: ${garagemsMin}` : ''}
    ${garagemsMax ? `,garagems_max: ${garagemsMax}` : ''}
    ${dormitoriosMin ? `,dormitorios_min: ${dormitoriosMin}` : ''}
    ${dormitoriosMax ? `,dormitorios_max: ${dormitoriosMax}` : ''}
    ${suitesMin ? `,suites_min: ${suitesMin}` : ''}
    ${suitesMax ? `,suites_max: ${suitesMax}` : ''}
    ${banheirosMin ? `,banheiros_min: ${banheirosMin}` : ''}
    ${banheirosMax ? `,banheiros_max: ${banheirosMax}` : ''}
    ${mapa ? `,mapa: ${mapa}` : `,mapa: 12`}
    ) {
        count,
        imoveis {
            exclu
            id
            mini_banner_texto
            tipo {
                nome
            }
            referencia
            data_entrega
            venda
            aluguel
            qtd_salas
            temporada
            area_total
            area_tipo
            area_privativa
            bairro {
                nome
            }
            cidade {
                nome
            }
            temporada
            latitude_longitude
            titulo
            fotos {
                url_foto
                url_spaces_cdn
                url_spaces_migracao
            }
        }
        }
    }
    `;

    try {
const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}

//query para pegar os imoveis em promoção para montar o mapa no site com latitude e longitude
export async function propertiesMapaPromocao(
    id_categoria: any,
    page: number,
    idCity?: number | null,
    idBairro?: any | null,
    idTipo?: any | null,
    referencia?: any,
    precoVendaMin?: number | null,
    precoVendaMax?: number | null,
    precoLocacaoMin?: number | null,
    precoLocacaoMax?: number | null,
    venda?: number,
    aluguel?: number,
    company?: number,
    ordenar?: any,
    garagemsMin?: number | null,
    dormitoriosMin?: number | null,
    suitesMin?: number | null,
    banheirosMin?: number | null,
    agenciador?: Number | null,
    temporada?: number,
    mapa?: number,
    origin?: any, codsite?: number
) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    let suitesMax = suitesMin
    if(suitesMin == 5)
        suitesMax = 0
    let garagemsMax = garagemsMin
    if(garagemsMin == 5)
        garagemsMax = 0
    let dormitoriosMax = dormitoriosMin
    if(dormitoriosMin == 5)
        dormitoriosMax = 0
    let banheirosMax = banheirosMin
    if(banheirosMin == 5)
        banheirosMax = 0

    const endpoint = BASE_URL;

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0
        },
    });
    const query = gql`
        {
            imoveis_promocao(pagina: ${page},
            ordenar: ${ordenar?.value?.split('-')[1] || 'Inclusao'},
            ordem: ${ordenar?.value?.split('-')[0] || 'desc'}
    ${id_categoria>0 ? ",id_categoria:"+id_categoria : ''}
    ${idCity ? `,id_cidade: ${idCity}` : ''}
    ${idBairro ? `,id_bairro: ${idBairro}` : ''}
    ${idTipo ? `,id_tipo: ${idTipo}` : ''}
    ${referencia?.length > 2 ? `,referencia: ${referencia}` : (`${venda ? `,venda: ${venda}` : ''}
    ${aluguel ? `,aluguel: ${aluguel}` : ''}
    ${temporada ? `,temporada: ${temporada}` : ''}
    ${precoVendaMin ? `,preco_venda_min: ${precoVendaMin}` : ''}
    ${precoVendaMax ? `,preco_venda_max: ${precoVendaMax ? precoVendaMax : 100000000}` : ''}
    ${precoLocacaoMin ? `,preco_locacao_min: ${precoLocacaoMin}` : ''}
    ${agenciador ? `,id_agenciador: ${agenciador}` : ''}
    ${precoLocacaoMax ? `,preco_locacao_max: ${precoLocacaoMax}` : ''}`)}
    ${company ? `,id_empreendimento: ${company}`: ''}
    ${garagemsMin ? `,garagems_min: ${garagemsMin}` : ''}
    ${garagemsMax ? `,garagems_max: ${garagemsMax}` : ''}
    ${dormitoriosMin ? `,dormitorios_min: ${dormitoriosMin}` : ''}
    ${dormitoriosMax ? `,dormitorios_max: ${dormitoriosMax}` : ''}
    ${suitesMin ? `,suites_min: ${suitesMin}` : ''}
    ${suitesMax ? `,suites_max: ${suitesMax}` : ''}
    ${banheirosMin ? `,banheiros_min: ${banheirosMin}` : ''}
    ${banheirosMax ? `,banheiros_max: ${banheirosMax}` : ''}
    ${mapa ? `,mapa: ${mapa}` : `,mapa: 12`}
    ) {
        count,
        imoveis {
            exclu
            id
            mini_banner_texto
            tipo {
                nome
            }
            referencia
            data_entrega
            venda
            qtd_salas
            origem
            aluguel
            temporada
            area_total
            area_tipo
            area_privativa
            bairro {
                nome
            }
            cidade {
                nome
            }
            temporada
            latitude_longitude
            titulo
            fotos {
                url_foto
                url_spaces_cdn
                url_spaces_migracao
            }
        }
        }
    }
    `;

    try {
        
const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}

export async function getManager(idImovel: number, origin?:  any, codsite?: number) {

    if (!origin && typeof window === 'undefined') {
        return null;
    }

    // Valida o ID como inteiro positivo suportado por GraphQL Int (32-bit).
    if (!isPositiveGraphqlInt(idImovel)) {
        return null;
    }


    const endpoint = BASE_URL;

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0,
            query: `imovel_participantes${idImovel}`
        },
    });

    const query = gql`
        {
            imovel_participantes(id_imovel: ${idImovel}) {
                parceiro {
                    id
                    nome
                    telefone
                    telefone_2
                    email
                    mostrar_equipe
                    descricao
                    funcao {
                      id
                      nome
                    }
                    url_foto
                    facebook
                    instagram
                    linkedin
                    link_proprio
                    creci
                }
            }
        }
    `;

    try {
        
        const data = await graphQLClient.request(query);
        return data;
    } catch (error) {
        return null;
    }
}

//query para pegar os dados do corretor/gestor pelo id
export async function getManagerId(idManager: number, origin?: any, codsite?: number) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    const endpoint = BASE_URL;

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0,
            query: `parceiros${idManager}`
        },
    });

    const query = gql`
        {
            parceiros (id: ${idManager}){
                id
                nome
                telefone
                telefone_2
                internacional
                email
                mostrar_equipe
                descricao
                funcao {
                    id
                    nome
                }
                url_foto
                facebook
                instagram
                linkedin
                link_proprio
                creci
            }
        }
    `;

    try {
        
const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}

//query para pegar os dados do lead pelo id
export async function getLeadId(idLead: number, origin?: any, codsite?: number) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    const endpoint = BASE_URL;

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0
        },
    });

    const query = gql`
        {
            clienteLead(id_lead: ${idLead}) {
                nome
                telefone
                email
            }
        }
    `;

    try {
        
const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}

//query para pegar os imoveis semelhantes a um imóvel especifico
export async function propertiesRelated(
    id: number,
    idCity: number,
    idType: number,
    preco_venda?: number,
    preco_locacao?: number,
    origin?: any, codsite?: number
) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    const endpoint = BASE_URL;

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0
        },
    });
    const query = gql`
        {
            imoveis_semelhantes(id: ${id}, ${idCity ? `id_cidade: ${idCity},` : ''}
            ${idType ? `id_tipo: ${idType}` : 'id_tipo:0'}
            ${preco_venda ? `,preco_venda: ${preco_venda}, venda: 1` : ''}
            ${preco_locacao ? `,preco_locacao: ${preco_locacao}, aluguel: 1` : ''}
    ) {
                id
                exclu
                pais
                tipo {
                    nome
                    id
                }
                categoria {
                    nome
                    id
                }
                cidade {
                    nome
                    id
                }
                bairro {
                    nome
                    id
                    id_cidade
                }
                referencia
                data_entrega
                venda
                aluguel
                endereco
                titulo
                descricao
                dormitorios
                suites
                banheiros
                garagems
                boxes
                mostrar_endereco
                exibir_preco_venda
                moeda_imovel
                preco_venda
                preco_iptu
                destaque
                link_video
                tour360
                preco_locacao
                exibir_preco_locacao
                exibir_preco_iptu
                area_construida
                latitude_longitude
                area_total
                area_tipo
                terreno
                area_privativa
                area_util
                palavras_chave
                fotos {
                    url_foto
                    url_spaces_cdn
                    url_spaces_migracao
                    destaque
                    id
                    id_imovel
                    nome
                    posicao
                    url_marca
                }
            }
        }
    `;

    try {
        const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}

//query para pegar os dados específicos de um imóvel pelo id
export async function propertiesSpecific(
    id: number,
    origin?: string, codsite?: number, url?: any,prodOrigin?: any
) {
    if (((!origin || origin == undefined || origin == 'undefined') && typeof window === 'undefined') || !isPositiveGraphqlInt(id)) {
        return null;
    }
    let endpoint = BASE_URL;

    if(prodOrigin)
        endpoint = WORKER_URL || "https://novaapi.sobressai.com.br/"
    else
        endpoint = '/api/gql'

    const graphQLClient = 
    prodOrigin ?
    new GraphQLClient(endpoint, {
        headers: {
            ...headers2,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0,
            query: `imovel_specific_${id}`
        },
    }) : new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0,
            query: `imovel_specific_${id}`
        },
    });

    const query = gql`
        {
            imovel(id: ${id}) {
                exclu
                id
                pais
                exibir_simulador
                bloquear_fotos
                usa_fotos_empreendimento
                tipo {
                id
                nome
                }
                categoria {
                id
                nome
                }
                cidade {
                id
                nome
                url_foto
                descricao
                }
                bairro {
                id
                nome
                id_cidade
                url_foto
                descricao
                }
                referencia
                data_entrega
                venda
                origem
                aluguel
                temporada
                data_edicao
                d1
                lado_direito
                lado_esquerdo
                frente
                fundos
                disponibilidade
                incorporacao
                latitude_longitude
                endereco
                titulo
                descricao
                dormitorios
                suites
                banheiros
                area_tipo
                garagems
                boxes
                mostrar_endereco
                complemento
                numero
                preco_venda
                exibir_preco_venda
                moeda_imovel
                preco_iptu
                destaque
                link_video
                preco_locacao
                exibir_preco_locacao
                exibir_preco_iptu
                exibir_preco_condominio
                preco_condominio
                area_construida
                area_total
                terreno
                tour360
                posicao_solar
                area_privativa
                area_util
                palavras_chave
                fotos {
                    id
                    id_imovel
                    nome
                    destaque
                    posicao
                    url_spaces_cdn
                    url_spaces_migracao
                    url_foto
                    url_foto_menor
                    url_marca
                }
                caracteristicas {
                caracteristica {
                    id
                    nome
                    tipo
                }
                }
                visualizacoes
                preco_especial {
                preco_especial_venda
                preco_especial_locacao
                }
                empreendimento {
                    id
                    nome
                    referencia
                    endereco
                    destaque
                    foto_destaque
                    meta_description
                    meta_keywords
                    meta_title
                    descricao
                    fotos {
                        id
                        descricao
                        posicao
                        destaque
                        url_foto
                    }
                }
            }
        }
    `;

    try {
        
const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}

//query para pegar os dados específicos de um imóvel pelo id
export async function propertiesSpecific1(
    id: number,
    origin?: string, codsite?: number, url?: any,prodOrigin?: any
) {
    if (((!origin || origin == undefined || origin == 'undefined') && typeof window === 'undefined') || !isPositiveGraphqlInt(id)) {
        return null;
    }
    let endpoint = BASE_URL;

    if(prodOrigin)
        endpoint = WORKER_URL || "https://novaapi.sobressai.com.br/"
    else
        endpoint = '/api/gql'

    const graphQLClient = 
    prodOrigin ?
    new GraphQLClient(endpoint, {
        headers: {
            ...headers2,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0,
            query: `imovel_specific1_${id}`
        },
    }) : new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0,
            query: `imovel_specific1_${id}`
        },
    });

    const query = gql`
        {
            imovel(id: ${id}) {
                exclu
                id
                pais
                exibir_simulador
                usa_fotos_empreendimento
                bloquear_fotos
                tipo {
                id
                nome
                }
                categoria {
                id
                nome
                }
                cidade {
                id
                nome
                }
                bairro {
                id
                nome
                id_cidade
                }
                referencia
                data_entrega
                venda
                aluguel
                temporada
                data_edicao
                d1
                origem
                disponibilidade
                incorporacao
                latitude_longitude
                titulo
                lado_direito
                lado_esquerdo
                frente
                fundos
                descricao
                dormitorios
                suites
                banheiros
                area_tipo
                garagems
                boxes
                mostrar_endereco
                preco_venda
                exibir_preco_venda
                moeda_imovel
                preco_iptu
                destaque
                link_video
                preco_locacao
                exibir_preco_locacao
                exibir_preco_iptu
                exibir_preco_condominio
                preco_condominio
                area_construida
                area_total
                terreno
                tour360
                posicao_solar
                area_privativa
                area_util
                palavras_chave
                fotos {
                    id
                    id_imovel
                    nome
                    destaque
                    posicao
                    url_spaces_cdn
                    url_spaces_migracao
                    url_foto
                    url_foto_menor
                    url_marca
                }
                caracteristicas {
                caracteristica {
                    id
                    nome
                    tipo
                }
                }
                visualizacoes
                preco_especial {
                preco_especial_venda
                preco_especial_locacao
                }
                empreendimento {
                    id
                    nome
                    referencia
                    endereco
                    destaque
                    meta_description
                    meta_keywords
                    meta_title
                    foto_destaque
                    descricao
                    fotos {
                        id
                        descricao
                        posicao
                        destaque
                        url_foto
                    }
                }
            }
        }
    `;

    try {
        
const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}

//query para enviar os dados do usuário que entrou em contato pelo formulário
export async function sendUser(
    internacional: boolean,
    utm_Campaign: string,
    utm_source: string,
    utm_Medium: string,
    utm_Id: string,
    mensagem: string,
    name: string,
    email: string,
    telephone: string,
    idProperties: number,
    agenciador?: number,
    origin?: string,
    codsite?: number,
    transacao_selecionada?: String,
    delegar_ao_agenciador?: number
    )
    {
        if (!origin && typeof window === 'undefined') {
            return null;
        }

        if (isLikelyBot()) return null;

        const endpoint = "/api/gql";

        const graphQLClient = new GraphQLClient(endpoint, {
            headers: {
                ...headers,
                dominion: typeof window !== 'undefined' ? window.location.origin : origin,
                'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
                codsite: codsite ? codsite : 0
            },
        });

    const query = gql`
        mutation Atendimento {
            atendimento(nome: ${name}, email: ${email},mensagem: ${mensagem},internacional: ${internacional ? true : false},telefone: ${telephone}, id_imovel: ${idProperties}${
        agenciador && delegar_ao_agenciador ? ',id_filiado:' + agenciador : ''
    }, origem: "site" ${utm_Campaign ? ", utm_campaign: " + utm_Campaign : ""}${utm_source ? ", utm_source: " + utm_source : ""}${utm_Medium ? ", utm_medium: " + utm_Medium : ""}${utm_Id ? ", utm_id: " + utm_Id : ""}${transacao_selecionada ? `, transacao_selecionada:  "${transacao_selecionada}"` : ""}) {
                id_atendimento
                id_cliente
                status
            }
        }
    `;

    try {
        
        const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}

export async function atualizaModelo(origin?: string, codsite?: number) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    if (isLikelyBot()) return null;

    const endpoint = "/api/gql";

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0
        },
    });

    const query = gql`
        mutation Mutation {
            modeloSite
        }
    `;

    try {
        
const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}

//query para registrar a visualização de um imóvel
export async function viewProperties(idProperties: number, idClient?: string, origin?: string, codsite?: number) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    if(!isPositiveGraphqlInt(idProperties))
        return null;

    if (isLikelyBot()) return null;

    const endpoint = "/api/gql";

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0
        },
    });

    const query = gql`
        mutation Visita {
            visita(id_imovel: ${idProperties} ${
        idClient ? `, id_cliente: ${idClient}` : ''
    }) {
                status
            }
        }
    `;

    try {
        const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}

//query para salvar os logs de acesso ao site
export async function salvaLogs(url: string, ip: string, origin?: string, codsite?: number) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    if (isLikelyBot()) return null;

    const endpoint = "/api/gql";

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0
        },
    });

    const query = gql`
        mutation salvaLogAcesso {
            salvaLogAcesso(url: "${url}"${ip ? `, ip: "${ip}"` : ''})
        }
    `;

    try {
        
const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}
